import React, { Component } from "react";
// import { connect } from "react-redux";
// import { getSchemas } from "../../../store/actions";
import { withRouter } from "react-router";

import Tables from "./Table";
// import Ecxell from "./Excell";

class AssetSchemas extends Component {
  render() {
    return (
      <React.Fragment>
        <Tables />
        {/* <Ecxell /> */}
      </React.Fragment>
    );
  }
}

export default withRouter(AssetSchemas);



// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/AssetSchemas.js